var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "wordpress (5)") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons---16",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon16/pic/thumb-up-copy",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "wordpress-(5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,0 C3.589,0 0,3.589 0,8 C0,12.411 3.589,16 8,16 C12.411,16 16,12.411 16,8 C16,3.589 12.411,0 8,0 Z M8,1 C9.413,1 10.727,1.424 11.828,2.147 C11.445,2.36 11.09,2.808 11.09,3.76 C11.09,4.266 11.435,4.853 11.834,5.533 C12.313,6.349 12.907,7.364 12.758,8.097 C12.594,8.582 12.178,9.683 11.727,10.858 L9.66,4.918 C9.702,4.907 9.749,4.9 9.789,4.887 C10.051,4.8 10.192,4.517 10.105,4.255 C10.017,3.993 9.735,3.854 9.472,3.939 C9.046,4.081 8.275,4.078 7.812,4.077 L7.673,4.077 L7.534,4.077 C7.074,4.078 6.3,4.081 5.874,3.939 C5.615,3.851 5.331,3.993 5.243,4.255 C5.155,4.517 5.297,4.8 5.559,4.887 C5.77,4.958 6.019,4.996 6.273,5.024 L7.503,8.222 L6.34,11.156 L4.353,4.94 C4.426,4.923 4.504,4.91 4.571,4.887 C4.833,4.8 4.975,4.517 4.887,4.255 C4.799,3.993 4.517,3.851 4.255,3.939 C3.83,4.081 3.057,4.077 2.594,4.077 L2.457,4.077 C2.367,4.077 2.293,4.07 2.217,4.064 C3.478,2.216 5.599,1 8,1 Z M1,8 C1,7.214 1.136,6.46 1.376,5.754 L4.444,14.019 C2.387,12.798 1,10.561 1,8 Z M8,15 C7.308,15 6.641,14.895 6.009,14.708 L8.033,9.6 L9.997,14.707 C9.364,14.895 8.694,15 8,15 Z M11.579,14.004 C12.227,12.343 13.343,9.466 13.678,8.493 L13.691,8.497 C13.705,8.457 13.72,8.405 13.73,8.344 C13.843,8.03 13.939,7.743 14.016,7.501 C14.263,6.72 14.42,6.033 14.502,5.425 C14.82,6.223 15,7.09 15,8 C15,10.551 13.624,12.781 11.579,14.004 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWp);
export default __webpack_public_path__ + "static/media/wp.39c89ad8c811c631afcd7efd764e0206.svg";
export { ForwardRef as ReactComponent };